import * as React from "react";

function SvgWatches(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g clipPath="url(#watches_svg__clip0)">
        <path d="M19.047 3.277L16.69.92a.833.833 0 00-1.037-.114l-4.72 3.004a6.678 6.678 0 015.224 5.224l3.004-4.72a.834.834 0 00-.114-1.037zM3.081 11.662l-3.004 4.72a.833.833 0 00.114 1.037l2.357 2.357a.842.842 0 001.037.114l4.72-3.004a6.677 6.677 0 01-5.224-5.224z" />
        <path d="M13.744 6.223a5.833 5.833 0 10-.631 8.797l.63.632 1.18-1.179-.632-.631a5.834 5.834 0 00-.547-7.619zm-7.34 7.34a4.547 4.547 0 113.215 1.333 4.517 4.517 0 01-3.216-1.332z" />
        <path d="M12.32 7.648a3.818 3.818 0 10-5.401 5.4 3.818 3.818 0 005.4-5.4zm-.344 3.534H9.62a.834.834 0 01-.79-.57l-.59-1.768 1.582-.527.399 1.198h1.756v1.667z" />
      </g>
    </svg>
  );
}

export default SvgWatches;
